import LegalDocViewer from "@/components/LegalDocViewer";
import content from "@/legal-rendered/expert_agreement";

export default function ExpertAgreementPage() {
  return (
    <LegalDocViewer
      title="Expert Agreement"
      subtitle="Independent contractor terms for Experts on the xpert.company marketplace"
      policyId="expert_agreement"
      policyVersion="1.1.0"
      content={content}
    />
  );
}
